import {
  Button,
  Dialog,
  DialogActions,
  Box,
  DialogContent,
  IconButton,
  DialogTitle,
  Typography,
  FormHelperText,
  TextField,
  Alert,
  Divider,
} from '@mui/material';
import { CustomErrorLogger } from '../../utils/CustomErrorLogger';
import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import Iconify from '../Iconify';
import * as Yup from 'yup';
import axios from 'axios';
import '../../css/users/addUserDialog.css';

export const AddRisqueDialog = ({
  setRisques,
  setTotalRisques,
  setFilteredRisquesCount,
  openAddRisque,
  setOpenAddRisque,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [errMsg, setErrMsg] = useState(null);

  const formik = useFormik({
    initialValues: {
      name: '',
      description: '',
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required(t('isRequired')),
      description: Yup.string().optional(),
    }),
    onSubmit: async (values) => {
      try {
        const formData = new FormData();
        formData.append('name', values.name || '');
        formData.append('description', values.description || '');

        const response = await axios.post('risk', formData);
        if (response.status === 200 || response.status === 201) {
          setRisques((prev) => [...prev, response.data]);
          setTotalRisques((prev) => prev + 1);
          setFilteredRisquesCount((prev) => prev + 1);
          setOpenAddRisque(false);
          setErrMsg(null);
          navigate(`risque_details/${response.data.id}`);
        }
      } catch (error) {
        setErrMsg(error.message || 'Erreur');
        CustomErrorLogger(error, "Erreur lors de l'ajout de la risque");
        console.error('Error adding risque:', error);
      }
    },
  });

  const { handleSubmit, values, handleChange, handleBlur, touched, errors } = formik;

  const handleClose = useCallback(() => {
    setOpenAddRisque(false);
    setErrMsg(null);
  }, [setOpenAddRisque]);

  return (
    <Dialog open={openAddRisque} fullWidth>
      <IconButton onClick={handleClose} className="addUser_icon_button">
        <Iconify icon="material-symbols:close" className="addUser_close_icon" />
      </IconButton>
      <DialogTitle className="addUser_dialog_title">{t('addRisqueDialogTitle')}</DialogTitle>
      <Divider />
      {errMsg && (
        <Alert key={errMsg} severity="error">
          {errMsg}
        </Alert>
      )}
      <form onSubmit={handleSubmit}>
        <DialogContent className="addUser_dialog_content">
          <Typography className="addUser_dialog_SubTitle">{t('addRisqueDialogSubTitle')}</Typography>
          <Box className="addUser_helper_selct_box">
            <FormHelperText className="addUserInputTitle">{t('Nom')}</FormHelperText>
            <TextField
              fullWidth
              value={values.name}
              className="addUser_InputField"
              onChange={handleChange}
              onBlur={handleBlur}
              name="name"
              error={touched.name && Boolean(errors.name)}
              helperText={touched.name && errors.name}
            />
          </Box>
          <Box className="addUser_helper_selct_box">
            <FormHelperText className="addUserInputTitle">
              {t('Description')} (optionnel)
            </FormHelperText>
            <TextField
              fullWidth
              value={values.description}
              className="addUser_InputField"
              onChange={handleChange}
              onBlur={handleBlur}
              name="description"
              error={touched.description && Boolean(errors.description)}
              helperText={touched.description && errors.description}
            />
          </Box>
        </DialogContent>
        <DialogActions className="addUser_dialog_actions">
          <Button className="addUser_button_annuler" onClick={handleClose}>
            {t('Annuler')}
          </Button>
          <Button className="addUser_button_valider" variant="contained" type="submit">
            {t('Valider')}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
